import { render, staticRenderFns } from "./LabelsChip.vue?vue&type=template&id=78ba2f55"
import script from "./LabelsChip.vue?vue&type=script&lang=js"
export * from "./LabelsChip.vue?vue&type=script&lang=js"
import style0 from "./LabelsChip.vue?vue&type=style&index=0&id=78ba2f55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports